<template>
    <div class="widget-container">
        <!--<el-select v-model="date.yearSelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateYear" clearable @clear="forceUpdateYear">-->
        <!--<el-option-->
        <!--v-for="item in year"-->
        <!--:key="item"-->
        <!--:label="item"-->
        <!--:value="item">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--<span v-show="showDes">年</span>-->
        <!--<el-select v-model="date.monthSelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateMonth" clearable @clear="forceUpdateMonth">-->
        <!--<el-option-->
        <!--v-for="item in month"-->
        <!--:key="item"-->
        <!--:label="item"-->
        <!--:value="item">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--<span v-show="showDes">月</span>-->
        <!--<el-select v-model="date.daySelect" placeholder="请选择" :class="{showDes:!showDes}" @change="forceUpdateDay" clearable @clear="forceUpdateDay">-->
        <!--<el-option-->
        <!--v-for="item in day"-->
        <!--:key="item"-->
        <!--:label="item"-->
        <!--:value="item">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--<span v-show="showDes">日</span>-->
        <div>
            <!--<el-cascader-->
            <!--v-model="value"-->
            <!--:options="options"-->

            <!--@change="handleChange"></el-cascader>-->
            <el-cascader @change="changeHandler" v-model="caValue" :options="options"></el-cascader>
        </div>
    </div>

</template>

<script type="text/ecmascript-6">
  import _ from 'lodash'

  export default {
    name: 'TimePicker',
    props: {
      showDes: {
        type: Boolean,
        default: true
      },
      value: '',
      date: {
        type: Object,
        default () {
          return {
            yearSelect: '',
            monthSelect: '',
            daySelect: ''
          }
        }
      },

    },
    data () {
      return {
        options: [{}],
        props: {
          lazy: true,
          lazyLoad: this.lazyLoad
        },
        caValue: '',
        // date:{
        //     yearSelect:'',
        //     monthSelect:'',
        //     daySelect:''
        // }
        monthHave: 0,
        day: [],
        month: []
      }
    },
    computed: {

      // month(){
      //     let monthStart = 1;
      //     let monthEnd = 12;
      //     let months = [];
      //     for(let i = monthStart;i<=monthEnd;i++){
      //         months.unshift(i);
      //     }
      //     months.unshift('下半年');
      //     months.unshift('上半年');
      //     months.unshift('不清楚');
      //     return months;
      // },
      //
      // monthHave(){
      //     console.log('monthHave ',this.date.yearSelect , this.date.monthSelect)
      //     if(_.isNumber(this.date.yearSelect) && _.isNumber(this.date.monthSelect)){
      //         return new Date(this.date.yearSelect,this.date.monthSelect,0).getDate();
      //     }
      //     return 0;
      // },

    },
    components: {},
    mounted () {
      this.initOptions()
      // this.monthHave = this.getMonthHave()
      // this.month = this.getMonth()
      // this.day = this.getDays();
    },
    methods: {
      // lazyLoad(node, resolve) {
      //   console.log('node',node)
      //   const { level,label } = node;
      //   if(level == 0) {
      //     this.initYearOption()
      //       .then((res) => {
      //         resolve(res)
      //       })
      //   }else if(level == 1) {
      //     // this.date.yearSelect = label
      //     setTimeout(() => {
      //       this.initMonthOption(label)
      //         .then(res => {
      //           resolve(res)
      //         })
      //     },300)
      //   }
      //   // else if(level == 2) {
      //   //   this.date.monthSelect = label
      //   //   this.monthHave = this.getMonthHave()
      //   //   setTimeout(()=> {
      //   //     this.initDayOptions()
      //   //       .then(res => {
      //   //         resolve(res)
      //   //       })
      //   //   },300)
      //   // }
      //   // let id = 0
      //   // console.log(level)
      //   // setTimeout(() => {
      //   //   const nodes = Array.from({ length: level + 1 })
      //   //     .map(item => ({
      //   //       value: ++id,
      //   //       label: `选项${id}`,
      //   //       leaf: level >= 2
      //   //     }));
      //   //   // 通过调用resolve将子节点数据返回，通知组件数据加载完成
      //   //   resolve(nodes);
      //   // }, 1000);
      // },
      changeHandler (value) {
        console.log(value)
        this.date.yearSelect = value[0]
        this.date.monthSelect = value[1]
        this.date.daySelect = value[2]
      },
      async initOptions () {
        this.options = await this.initYearOption()
      },
      initYearOption () {
        return new Promise(resolve => {
          let year = this.getYear()
          console.log(year)
          let options = year.reduce((arr, item, index) => {
            arr.push({
              value: item + '',
              label: item + '',
              children: this.initMonthOption(item),
              leaf: false
            })
            return arr
          }, [])
          resolve(options)
        })
      },
      initMonthOption (year) {
        let month = this.getMonth(year)
        let options = month.reduce((arr, item, index) => {
          arr.push({
            value: item + '',
            label: item + '',
            children: this.initDayOptions(year,item),
            leaf: true
          })
          return arr
        }, [])
        return options
      },
      initDayOptions (year,month) {
        let day = this.getDays(year,month)
        let options = day.reduce((arr, item, index) => {
          arr.push({
            value: item + '',
            label: item + '',
            leaf: true
          })
          return arr
        }, [])
        return options
      },
      loadSelectData () {
        this.monthHave = this.getMonthHave()
        this.month = this.getMonth()
        this.day = this.getDays()
      },
      getYear () {
        let start = 1969
        let end = new Date().getFullYear()

        let years = []
        for (let i = start; i <= end; i++) {
          years.unshift(i)
        }
        years.unshift('不清楚')
        return years

      },
      getMonthHave (year,month) {
        if (_.isNumber(parseInt(year, 10))) {
          if (_.isNaN(parseInt(month, 10))) {
            return 0
          } else {
            if (parseInt(year, 10) == new Date().getFullYear() && parseInt(month, 10) == new Date().getMonth() + 1) {
              return new Date().getDate()
            }
            return new Date(year, month, 0).getDate()
          }

        }
        return 0
      },
      getDays (year,month) {
        let monthHave = this.getMonthHave(year,month)
        let dayStart = 1
        let days = []
        for (let i = dayStart; i <= monthHave; i++) {
          days.unshift(i)
        }
        days.unshift('不清楚')
        return days
      },
      getMonth (yearSelect) {
        let months = []

        if (yearSelect == '不清楚') {
          months = ['不清楚']
        } else {
          let monthStart = 1
          let monthEnd = 12
          if (yearSelect == new Date().getFullYear()) {
            monthEnd = new Date().getMonth() + 1
          }
          for (let i = monthStart; i <= monthEnd; i++) {
            months.unshift(i)
          }
          if (yearSelect == new Date().getFullYear()) {
            let currentMonth = new Date().getMonth() + 1
            if (currentMonth > 6) {
              months.unshift('下半年')
            }
          } else {
            months.unshift('下半年')
          }
          months.unshift('上半年')
          months.unshift('不清楚')
        }
        return months
      },
      // forceUpdateYear() {
      //   this.monthHave = this.getMonthHave()
      //   this.month = this.getMonth()
      //   this.day = this.getDays();
      //   if (yearSelect == '至今') {
      //     this.date.monthSelect = '至今'
      //     this.date.daySelect = '至今'
      //   } else if (yearSelect == '不清楚') {
      //     this.date.monthSelect = '不清楚'
      //     this.date.daySelect = '不清楚'
      //     this.date.hourSelect = '不清楚'
      //     this.date.minuteSelect = '不清楚'
      //   } else {
      //     this.date.daySelect = ''
      //     this.date.monthSelect = ''
      //     this.date.hourSelect = ''
      //     this.date.minuteSelect = ''
      //   }
      //   this.$forceUpdate()
      // },
      forceUpdateMonth () {
        this.monthHave = this.getMonthHave()
        this.day = this.getDays()
        this.date.daySelect = ''
        this.$forceUpdate()
      },
      forceUpdateDay () {
        this.$forceUpdate()
      }
    },
    created () {
    }
  }
</script>

<style scoped lang="scss">
    .widget-container {
        & > .el-select {
            width: 110px;
            margin-left: 25px;
            margin-right: 25px;
        }

        & > .el-select.showDes {
            margin-left: 12px;
            margin-right: 12px;

            &:nth-of-type(1) {
                margin-left: 25px;
            }
        }
    }
</style>
